import React, { useRef } from "react";
import { AspirerAcquisitionCampaignControl } from "web/react/components/aspirer-acquisition-campaign-control/aspirer-acquisition-campaign-control";
import { CollectionGrid } from "web/react/components/curated-collection/collection-grid/collection-grid";
import { Header } from "web/react/components/curated-collection/header";
import { CustomerCaptureOverlay } from "web/react/components/customer-capture-overlay/customer-capture-overlay";
import { ProductOverlay } from "web/react/components/product-overlay";
import { ArchiveDeviceDivider } from "web/react/emo/archive-device-divider";
import { Text } from "web/react/emo/text";
import { useIntersectionObserver } from "web/react/hooks/use-intersection-observer/use-intersection-observer";
import { gettext } from "web/script/modules/django-i18n";
import environment from "web/script/modules/environment";
import { CuratedCollectionSerializer } from "web/types/serializers";
import * as styles from "./curated-collection.css";

interface CuratedCollectionProps {
    curated_collection: CuratedCollectionSerializer;
}

export function CuratedCollection({
    curated_collection,
}: CuratedCollectionProps): React.ReactElement {
    const { sponsored, header, feed_items: feedItems, slug } = curated_collection;

    const sponsoredDisclaimer = gettext("editorial.sponsored_disclaimer");
    const standardDisclaimer = gettext("editorial.standard_disclaimer");

    const overlayRef = useRef(null);

    const triggerModalRef = useRef<HTMLDivElement>(null);
    const [triggerModal] = useIntersectionObserver(
        {
            threshold: 0,
            rootMargin: "0px",
            once: true,
        },
        triggerModalRef
    );

    const useModal = environment.getFeature(
        "crm_signup_modal_on_editorial_and_curated_collections"
    );

    return (
        <div>
            <CustomerCaptureOverlay />
            {useModal && !sponsored && (
                <AspirerAcquisitionCampaignControl isVisible={triggerModal} timeout={2800} />
            )}

            <div ref={overlayRef}>
                <ProductOverlay parentRef={overlayRef} pageType="editorial" />
            </div>

            <div className={styles.wrapper}>
                <div className={styles.container}>
                    <Header {...header} slug={slug} sponsored={sponsored} />
                    <div ref={triggerModalRef} />
                    <Text className={styles.sponsored} textStyle="caption-3" upperCase>
                        {sponsored ? sponsoredDisclaimer : standardDisclaimer}
                    </Text>
                </div>
                <ArchiveDeviceDivider />
                <div className={styles.container}>
                    <CollectionGrid feedItems={feedItems} slug={slug} sponsored={sponsored} />
                </div>
                <ArchiveDeviceDivider />
            </div>
        </div>
    );
}
